"use client";

import { FC, useMemo } from "react";
import { TextResources } from "@portal/assets/text/TextResources";
import { IBookEquityGraphProps } from "./types";
import PortalPageBox from "@portal/components/atoms/portalPageBox";
import BookEquityChart from "./graph";
import Typography from "@portal/components/atoms/v2/typography";

const BookEquityGraph: FC<IBookEquityGraphProps> = ({ equityList, tradeHistory }) => {
  const equityListSorted = useMemo(() => equityList
    ?.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()), [equityList]);

  const tradeHistorySorted = useMemo(() => tradeHistory
    ?.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()), [tradeHistory]);

  if ((equityListSorted === undefined || equityListSorted.length === 0) && (tradeHistorySorted === undefined || tradeHistorySorted.length === 0))
    return null;

  return (
    <PortalPageBox className="space-y-2">
      <div>
        <Typography variant="H6">{TextResources.UNLISTED_SECURITIES_EQUITY_TRADE_GRAPH_TITLE}</Typography>
      </div>
      <BookEquityChart equityList={equityListSorted} tradeHistory={tradeHistorySorted} />
      <div>
        <Typography variant="Description">{TextResources.UNLISTED_SECURITIES_DEVELOPMENT_TEXT}</Typography>
      </div>
    </PortalPageBox>
  );
};

export default BookEquityGraph;
